import React from 'react'

import Navbar from 'components/Navbar'
import { LoadingPlaceholder } from '@sketch/components'
import { SplitLayout } from 'layouts/SplitLayout'

import {
  SidebarWrapper,
  LoadingWrapper,
  LoadingSidebarWorkspace,
} from './WorkspaceSidebarLayout.styles'

const LoadingWorkspaceSidebarLayout = () => (
  <SplitLayout
    header={<Navbar />}
    sidebar={
      <SidebarWrapper>
        <LoadingSidebarWorkspace />
      </SidebarWrapper>
    }
    footer={null}
  >
    <LoadingWrapper>
      <LoadingPlaceholder size="64px" />
    </LoadingWrapper>
  </SplitLayout>
)

export default LoadingWorkspaceSidebarLayout
